import Vue from "vue";

export default {
	SET_ALL(state, {collection, data}){
		Vue.set(state, collection, data )
	},
	SET_ONE(state, {doc, collection}){
		var curr = state[collection].indexOf( state[collection].find( item => item.id == doc.id ) );
		if( curr > -1 ){
			Vue.set(state[collection], curr, doc )
		}
		else{
			Vue.set(state[collection], state[collection].length, doc )
		}
	}
}